

<template>
	<nav class="nav-mobile"  :class="{'has-back':current.parent}">
		
		<transition name="fade">
			<component class="back" v-if="current.parent" is="MobileBackButton"></component>
		</transition>

		<div class="menue">

			<transition-group
				v-on:enter="hotspotEnter" 
				v-on:leave="hotspotLeave"
				v-bind:css="false">
					<component v-if="hotspots && hotspots.length" :index="index" is="MobileHotspotButton" :hotspot="hotspot" :key="`hotspot-${index}`" v-for="(hotspot, index) in hotspots">
						<div class="d-flex align-items-center">
							<div>
								<h6>{{ hotspot.title || hotspot.article }}</h6>
								<p>{{ hotspot.subtitle }}</p>
							</div>
							<i class="far fa-arrow-right ml-auto"></i>
						</div>
					</component>
			</transition-group>

			<transition-group
				v-on:enter="navEnter" 
				v-on:leave="navLeave"
				v-bind:css="false">
					<component is="MobileButton" :node="child" :index="index" :key="child.url" v-for="(child, index) in menue" :link="child.url">
						<i class="far fa-arrow-right mr-1"></i> {{ child.name }}
					</component>
			</transition-group>

		</div>
	</nav>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'

import { gsap, TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Expo } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin'
gsap.registerPlugin(CSSPlugin);

export default {
	store,
	props: ['current', 'menue', 'hotspots'],
	data: () => {
		return {
			prevMenue: [],
			prevHotspots: [],
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
	},
	watch: {
		menue( newVal, oldVal ) {
			this.prevMenue = oldVal || [];
		},
		hotspots( newVal, oldVal ) {
			this.prevMenue = newVal || oldVal;
			this.prevHotspots = oldVal;
		},
	},
	methods: {
		/**
		 * 	Animationen für Ein/Ausblenden der Navigation
		 * 	bei Wechsel der Levels.
		 * 
		 */
		navEnter(el, done) {
			var prev = Math.max(
				this.prevMenue ? this.prevMenue.length : 0, 
				this.prevHotspots ? this.prevHotspots.length : 0
			);
			TweenMax.fromTo(el, 0.5, {
				autoAlpha: 0,
				position: 'absolute',
				x: 100,
			}, {
				autoAlpha: 1,
				x: 0,
				position: 'relative',
				delay: (0.5 + prev * 0.1) + el.dataset.index * 0.1,
				ease: Power4.easeOut,
				onComplete: done
			});
		},
		navLeave(el, done) {
			TweenMax.fromTo(el, 0.5, {
				alpha: 1,
			}, {
				alpha: 0,
				delay: (this.prevMenue.length - el.dataset.index) * 0.1,
				ease: Power4.easeOut
			});
			setTimeout( done, (0.5 + this.prevMenue.length * 0.1) * 1000 );
		},
		/**
		 * 	Animationen für Ein/Ausblenden der Hotspots
		 *	(in Mobile Version als Menüpunkt dargestellt)	
		 * 	bei Wechsel der Levels.
		 * 
		 */
		hotspotEnter(el, done) {
			TweenMax.fromTo(el, 1, {
				alpha: 0,
				x: 100,
			}, {
				alpha: 1,
				x: 0,
				delay: 1 + (el.dataset.index * 0.1),
				ease: Power4.easeOut,
				onComplete: done
			});
		},
		hotspotLeave(el, done) {
			TweenMax.fromTo(el, 0.5, {
				alpha: 1,
			}, {
				alpha: 0,
				delay: (this.prevHotspots.length - el.dataset.index) * 0.1,
				ease: Power4.easeOut
			});
			setTimeout( done, (0.5 + this.prevHotspots.length * 0.1) * 1000 );
		},
	}

}
</script>

<style scoped lang="scss">
	.nav-mobile {
		h6 {
			font-weight: 600;
			margin: 0 0 0.3rem 0;
		}
		p {
			margin: 0;
		}
	}
	.menue {
		padding-left: 2rem;
	}
	.back {
		position: fixed;
		top: calc(60% + 37px);
		left: 1rem; 
	}
</style>
